import { render } from "./ScrollMenu.vue?vue&type=template&id=4de4617f&scoped=true"
import script from "./ScrollMenu.vue?vue&type=script&lang=js"
export * from "./ScrollMenu.vue?vue&type=script&lang=js"

import "./ScrollMenu.vue?vue&type=style&index=0&id=4de4617f&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de4617f"]])

export default __exports__